import { useEffect } from "react";

import Style from "./style";

import MainHeader from "widget/MainHeader";

import TStyle from "shared/style/tableStyle";
import useFetch from "shared/model/useFetch";
import timestampCalculator from "shared/lib/timestampCalculator";

/**
 * @Desc 매장이용권 거래 내역 (New)
 * @Access 프렌차이즈 매니저, 매장(지점) 매니저
 *
 * @Api 프렌차이즈는 모든 지점(매장)과 매장이용권을 주고 받은 거래 내역
 * @ResponseData 거래IDX, 지점명, 매니저이름, 분류(지급,회수,반환), 개수(분류로 인한개수), 거래날짜, is_mine: true
 *
 * @Api 지점(매장)매니저는 속한 프렌차이즈와 매장이용권을 주고 받은 거래 내역
 * @ResponseData 거래IDX, 지점명, 매니저이름, 분류(지급,회수,반환), 개수(분류로 인한개수), 거래날짜, is_mine: false
 *
 * @Role 매장이용권을 매니저에게 지급했지만, 내역이 표시되지 않음
 */
const MyFranchiseTicket = () => {
  const [fetchResult, fetchRequest] = useFetch();

  useEffect(() => {
    fetchRequest("GET", "/admin/store_ticket/transfer_record");
  }, []);

  console.log("fetchResult:", fetchResult);

  return (
    <Style.Wrapper>
      <MainHeader>이용권 거래 내역</MainHeader>
      <Style.AreaDiv>
        <TStyle.TableDiv>
          <TStyle.TableRow $title>
            <TStyle.Data $title $size={"short"}>
              IDX
            </TStyle.Data>
            <TStyle.Data $title $size={"expand"}>
              지점명
            </TStyle.Data>
            <TStyle.Data $title $size={"longlonglong"}>
              매니저 이름
            </TStyle.Data>
            <TStyle.Data $title $size={"long"}>
              분류
            </TStyle.Data>
            <TStyle.Data $title $size={"long"}>
              개수
            </TStyle.Data>
            <TStyle.Data $title $size={"long"}>
              거래날짜
            </TStyle.Data>
          </TStyle.TableRow>
          {fetchResult?.data?.items?.map((item) => {
            const typeName = {
              ISSUE: "지급",
              REVOKE: "회수",
              RETURN: "반환",
            };
            return (
              <TStyle.TableRow>
                <TStyle.Data $size={"short"}>{item.id}</TStyle.Data>
                <TStyle.Data $size={"expand"}>{item.storeName}</TStyle.Data>
                <TStyle.Data $size={"longlonglong"}>
                  {item.managerName}
                </TStyle.Data>
                <TStyle.Data $size={"long"}>{typeName[item.type]}</TStyle.Data>
                <TStyle.Data $size={"long"}>{item.count}</TStyle.Data>
                <TStyle.Data $size={"long"}>
                  {timestampCalculator(item.recordAt)}
                </TStyle.Data>
              </TStyle.TableRow>
            );
          })}
        </TStyle.TableDiv>
      </Style.AreaDiv>
    </Style.Wrapper>
  );
};

export default MyFranchiseTicket;
